import './styles.scss';

import { faChevronRight, faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Drawer } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { isNavLabelEnabled } from '../../../config/feature-flags';
import ImersiveLogoDark from '../../../assets/immersive-logo-dark.svg';
import { AppBarlink } from '../appbar';

interface DrawerMenuProps {
  open: boolean;
  onClose: () => void;
  links: AppBarlink[];
  onClick: (label: string) => void;
}

const DrawerMenu: React.FC<DrawerMenuProps> = ({ open, onClose, links, onClick }) => {
  const ImmersiveLogo = ImersiveLogoDark;

  const handleClick = (label: string) => {
    onClose();
    onClick(label);
  };

  const handleClose = () => {
    onClose();
  };

  const renderLinks = () => {
    return links.map((link) => {
      // Feature-gated entry: greyed + non-clickable on mobile when its flag is OFF.
      // OFF-mode greying only; restricted (ON) mode removes feature-off links
      // upstream so this never fires. Keep it - production (OFF) greys.
      const enabled = isNavLabelEnabled(link.label);
      return (
        <Button
          className="drawer-link-item"
          key={link.label}
          disabled={!enabled}
          onClick={() => handleClick(link.label)}
        >
          <label>{link.label}</label>
          <FontAwesomeIcon icon={faChevronRight} className="drawer-link-icon" />
        </Button>
      );
    });
  };

  return (
    <Drawer open={open} onClose={onClose} className="drawer-menu">
      <div className="drawer-container">
        <div className="drawer-header">
          <RouterLink
            to="/dashboard"
            className="drawer-header-logo"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <img src={ImmersiveLogo} alt="Immersive finance" />
          </RouterLink>
          <Button className="drawer-close-button" onClick={handleClose}>
            <FontAwesomeIcon icon={faX} className="drawer-close-icon" />
          </Button>
        </div>
        <div className="drawer-content">{renderLinks()}</div>
      </div>
    </Drawer>
  );
};

export default DrawerMenu;
